<script setup>
import { computed } from 'vue';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import {
  CUSTOMER_RECEIPT_STATUS,
  getCustomerReceiptStatus,
} from 'dashboard/helper/customerReceiptHelper';

import MessageStatus from './MessageStatus.vue';
import Icon from 'next/icon/Icon.vue';
import { useInbox } from 'dashboard/composables/useInbox';
import { useMessageContext } from './provider.js';

const { inbox } = useInbox();

const {
  status,
  isPrivate,
  createdAt,
  sourceId,
  messageType,
  contentAttributes,
} = useMessageContext();

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, h:mm a')
);

const statusToShow = computed(() =>
  getCustomerReceiptStatus(
    {
      status: status.value,
      private: isPrivate.value,
      sourceId: sourceId.value,
      messageType: messageType.value,
      contentAttributes: contentAttributes.value,
    },
    inbox.value
  )
);

const showStatusIndicator = computed(
  () => statusToShow.value !== CUSTOMER_RECEIPT_STATUS.HIDDEN
);
</script>

<template>
  <div class="text-xs flex items-center gap-1.5">
    <div class="inline">
      <time class="inline">{{ readableTime }}</time>
    </div>
    <Icon v-if="isPrivate" icon="i-lucide-lock-keyhole" class="size-3" />
    <MessageStatus v-if="showStatusIndicator" :status="statusToShow" />
  </div>
</template>
